import { TypedDocumentNode, gql } from '@apollo/client';

import { IncompleteLeaderboard } from './IncompleteLeaderboard';
import { SeasonLeaderboardList } from './SeasonLeaderboardList';
import { SeasonLeaderboardPodium } from './SeasonLeaderboardPodium';
import {
  SeasonLeaderboard_footballRivalsDivisionLeaderboard,
  SeasonLeaderboard_footballRivalsDivisionLeaderboardConfig,
} from './__generated__/index.graphql';

type Props = {
  featuredManagerId: string;
  configs: SeasonLeaderboard_footballRivalsDivisionLeaderboardConfig[];
  seasonSlug: string;
  userSlug: string;
  userLeaderboard: SeasonLeaderboard_footballRivalsDivisionLeaderboard;
  selectedUserSlug?: string;
  isCurrentSeason: boolean;
};
export const SeasonLeaderboard = ({
  featuredManagerId,
  configs,
  seasonSlug,
  userSlug,
  userLeaderboard,
  selectedUserSlug,
  isCurrentSeason,
}: Props) => {
  const { rankings, leaderboardConfig, rankingsCount } = userLeaderboard;
  const { promotedCount, relegatedCount, maximumSize } = leaderboardConfig;

  const leaderboardConfigIndex = configs.findIndex(
    ({ divisionConfig: config }) =>
      config.title === leaderboardConfig.divisionConfig.title
  );

  const upperLeaderboardConfig = configs[leaderboardConfigIndex + 1];
  const lowerLeaderboardConfig = configs[leaderboardConfigIndex - 1];

  const rankingsCopy = [...rankings];
  const promotedRankings = rankingsCopy.splice(0, promotedCount);
  const relegatedRankings =
    relegatedCount > 0 ? rankingsCopy.splice(-1 * relegatedCount) : [];
  const incompleteLeaderboard = rankingsCount < maximumSize;

  return (
    <div>
      {incompleteLeaderboard ? (
        <IncompleteLeaderboard
          isCurrentSeason={isCurrentSeason}
          rankingsCount={rankingsCount}
          maximumSize={maximumSize}
        />
      ) : (
        <SeasonLeaderboardPodium
          configs={configs}
          leaderboard={userLeaderboard}
        />
      )}
      <SeasonLeaderboardList
        promotedSectionTitle={upperLeaderboardConfig?.divisionConfig.title}
        relegatedSectionTitle={lowerLeaderboardConfig?.divisionConfig.title}
        promotedRankings={promotedRankings}
        relegatedRankings={relegatedRankings}
        unrelegatedRankings={rankingsCopy}
        featuredManagerId={featuredManagerId}
        seasonSlug={seasonSlug}
        userSlug={userSlug}
        selectedUserSlug={selectedUserSlug}
      />
    </div>
  );
};

SeasonLeaderboard.fragments = {
  footballRivalsDivisionLeaderboard: gql`
    fragment SeasonLeaderboard_footballRivalsDivisionLeaderboard on FootballRivalsDivisionLeaderboard {
      id
      season {
        id
        slug
      }
      leaderboardConfig {
        promotedCount
        relegatedCount
        maximumSize
        divisionConfig {
          id
          title
        }
      }
      rankingsCount
      rankings {
        id
        ...SeasonLeaderboardList_footballRivalsDivisionRanking
      }
      ...SeasonLeaderboardPodium_footballRivalsDivisionLeaderboard
    }
    ${SeasonLeaderboardPodium.fragments.footballRivalsDivisionLeaderboard}
    ${SeasonLeaderboardList.fragments.footballRivalsDivisionRanking}
  ` as TypedDocumentNode<SeasonLeaderboard_footballRivalsDivisionLeaderboard>,
  footballRivalsDivisionLeaderboardConfig: gql`
    fragment SeasonLeaderboard_footballRivalsDivisionLeaderboardConfig on FootballRivalsDivisionLeaderboardConfig {
      divisionConfig {
        id
        title
      }
      ...SeasonLeaderboardPodium_footballRivalsDivisionLeaderboardConfig
    }
    ${SeasonLeaderboardPodium.fragments.footballRivalsDivisionLeaderboardConfig}
  ` as TypedDocumentNode<SeasonLeaderboard_footballRivalsDivisionLeaderboardConfig>,
};
